import autoBind from 'react-autobind';
import {CharacterSymbol} from '../../shared/components';
import {connect} from 'react-redux';
import {handleApiError} from '../../shared/services';
import Tooltip from 'material-ui/internal/Tooltip';
import {withRouter} from 'react-router';

import {
  hideBadgeToolTip,
  loadAllBadges,
  showBadgeToolTip,
} from '../actions';

import {List, Map} from 'immutable';

import React, {Component, PropTypes} from 'react';

class SideNavigationBadges extends Component {
  constructor(props) {
    super(props);

    autoBind(this);
  }

  componentDidMount() {
    const {router} = this.props;

    this.props.loadAllBadges()
      .catch(error => handleApiError(error, router, 'An unexpected error occurred while attempting to load All Badges.', 'Error'));
  }

  handleMouseEnter(characterName, foundation, earned) {
    this.props.showBadgeToolTip(characterName, foundation, earned);
  }

  handleMouseLeave(characterName) {
    this.props.hideBadgeToolTip(characterName);
  }

  handleOnClick(characterId) {
    this.props.router.push(`/detail/${characterId}`);
  }

  render() {
    const {allBadges, earnedBadges, showTooltip} = this.props;

    const badges = allBadges.map(badge => {
      const badgeEarned = earnedBadges.includes(badge.get('id'));
      const toolTipOpen = showTooltip.get(badge.get('characterName'));

      const toolTipText =
        <div className="tool-tip">
          <div className="title">{`${badge.get('characterName')} / ${badge.get('foundation')}`}</div>
          <div className="sub-title">{badge.get('careerPathway')}</div>
          <div className="completed-notification">{badgeEarned ? 'Complete' : 'Not Complete'}</div>
        </div>;

      return (
        <div key={badge.get('id')}
             onClick={this.handleOnClick.bind(this, badge.get('characterId'))}
             className={`badge-icon ${badgeEarned ? 'earned' : ''}`} >
          <div className="symbol-wrapper"
               onMouseEnter={this.handleMouseEnter.bind(this, badge.get('characterName'), badge.get('foundation'), badgeEarned)}
               onMouseLeave={this.handleMouseLeave.bind(this, badge.get('characterName'))}>
            <CharacterSymbol key={badge.get('id')} source={badge.get('iconImageName')} />
          </div>
          <Tooltip key={badge.get('characterName')}
                   show={toolTipOpen}
                   label={toolTipText}
                   style={{left: 30}}
                   className={`tool-tip-wrapper ${toolTipOpen ? 'open' : ''}`}
                   horizontalPosition="right"
                   verticalPosition="top"
                   touch />
        </div>);
    });

    return (
      <div className="side-navigation-badges">
        {badges}
      </div>
    );
  }
}

SideNavigationBadges.propTypes = {
  allBadges: PropTypes.instanceOf(List).isRequired,
  earnedBadges: PropTypes.instanceOf(List).isRequired,
  hideBadgeToolTip: PropTypes.func.isRequired,
  loadAllBadges: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  showBadgeToolTip: PropTypes.func.isRequired,
  showTooltip: PropTypes.instanceOf(Map).isRequired,
};

function mapStateToProps(state) {
  const {navigationBadges} = state.features.sideNavigationBadges.pages;

  return {
    allBadges: navigationBadges.get('allBadges'),
    earnedBadges: navigationBadges.get('earnedBadges'),
    showTooltip: navigationBadges.get('showTooltip'),
  };
}

export default withRouter(connect(
  mapStateToProps,
  {
    hideBadgeToolTip,
    loadAllBadges,
    showBadgeToolTip,
  },
)(SideNavigationBadges));



// WEBPACK FOOTER //
// ./app/features/sideNavigationBadges/components/SideNavigationBadges.js